/**
 * 라벨 + 스위치 한 줄 — 설정 화면에서 반복되는 형태.
 *
 * Radix Switch 는 <button role="switch"> 로 렌더되므로 <label> 로 감싸도
 * 브라우저가 자동 연결하지 않는다. id/htmlFor 로 명시 연결해야 스크린리더가
 * 이름을 읽고, 라벨 클릭으로도 토글된다.
 */

import { useId } from 'react'
import { Switch } from '@cupia/ui/switch'
import { Label } from '@cupia/ui/label'

export interface SwitchRowProps {
  label: string
  description?: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  /**
   * 읽기 전용 — 값은 보여 주되 바꿀 수 없다(예: 개설 시점에 확정된 항목).
   * 바꿀 수 없는 것을 조작 가능한 스위치로 그리면, 껐다고 믿은 사용자가
   * 실제로는 켜진 상태로 계속 가게 된다.
   */
  disabled?: boolean
}

export function SwitchRow({
  label,
  description,
  checked,
  onCheckedChange,
  disabled = false,
}: SwitchRowProps): React.ReactElement {
  const id = useId()

  return (
    <div className={`flex items-start justify-between gap-3${disabled ? ' opacity-70' : ''}`}>
      <div className="flex flex-col">
        <Label htmlFor={id} className="text-(length:--text-sm-size) font-medium">
          {label}
        </Label>
        {description && (
          <span className="text-(length:--text-xs-size) text-[var(--color-muted-foreground)]">
            {description}
          </span>
        )}
      </div>
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
      />
    </div>
  )
}
